import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$2 } from './form-control-error-text2.js';
import { d as defineCustomElement$1 } from './form-control-help-text2.js';

const DateInput = /*@__PURE__*/ proxyCustomElement(class DateInput extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.formControlInput = createEvent(this, "formControlInput", 7);
        this.formControlBlur = createEvent(this, "formControlBlur", 7);
        this.handleFormControlInput = (event) => {
            const target = event.target;
            const name = target.getAttribute('name');
            this.inputHandler(name, target.value);
            this.formControlInput.emit({ name, value: target.value });
        };
        this.name = undefined;
        this.label = undefined;
        this.inputHandler = undefined;
        this.defaultValue = undefined;
        this.helpText = undefined;
        this.errorText = undefined;
        this.disabled = undefined;
    }
    handleDefaultValueChange(newValue) {
        this.updateInput(newValue);
    }
    componentDidLoad() {
        this.updateInput(this.defaultValue);
    }
    updateInput(value) {
        this.dateInput.value = value;
    }
    render() {
        return (h(Host, { key: 'dfbfc1ea5d7139a1c1d30c7bd84b33a9c22604cf', exportparts: "label,input,input-invalid" }, h("label", { key: '99a01781ecd1421fa439ad08f77d3f750a55eaee', part: "label", class: "form-label", htmlFor: this.name }, this.label), h("input", { key: 'd8db68d8a62e0f982c3aa7d4bd3a5cf7c2681db3', type: "date", ref: el => (this.dateInput = el), id: this.name, name: this.name, onBlur: this.formControlBlur.emit, onInput: this.handleFormControlInput, part: `input ${this.errorText && 'input-invalid'}`, class: this.errorText ? 'form-control is-invalid' : 'form-control', disabled: this.disabled }), h("form-control-help-text", { key: '1ee2ccdc1e409c5427e39efe2929b830960edce9', helpText: this.helpText, name: this.name }), h("form-control-error-text", { key: '1db50cca364b4d059dac37243cf83bb4b11459cd', errorText: this.errorText, name: this.name })));
    }
    static get watchers() { return {
        "defaultValue": ["handleDefaultValueChange"]
    }; }
}, [0, "form-control-date", {
        "name": [1],
        "label": [1],
        "inputHandler": [16],
        "defaultValue": [1, "default-value"],
        "helpText": [1, "help-text"],
        "errorText": [1, "error-text"],
        "disabled": [4]
    }, undefined, {
        "defaultValue": ["handleDefaultValueChange"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["form-control-date", "form-control-error-text", "form-control-help-text"];
    components.forEach(tagName => { switch (tagName) {
        case "form-control-date":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, DateInput);
            }
            break;
        case "form-control-error-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "form-control-help-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { DateInput as D, defineCustomElement as d };
